import "core-js/stable";
import "regenerator-runtime/runtime";
import "../css/tailwind.css"; // Tailwind enabled WITHOUT Preflight reset

import select from "dom-select";
import throttle from "lodash.throttle";
import { Swiper } from "swiper";
import { Autoplay, EffectFade, Pagination } from "swiper/modules";
import { classy as cl } from "./helpers/classy";
import { scrollLock, scrollUnLock } from "./helpers/scrollLock";
import Spoilers from "./helpers/spoilers";
import Faqs from "./helpers/faqs";
import videoResize from "./helpers/videoResize";
import VanillaTilt from "vanilla-tilt";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollSmoother from "gsap/ScrollSmoother";
import axios from "./helpers/axios";
import serialize from "form-serialize";
import { initFormie } from "./helpers/formie";
import { init_animations, init_scroll_effects, animate_added, init_page_leave } from "./helpers/animate";
import viewportUnitsBuggyfill from "viewport-units-buggyfill";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

(function (doc, win) {
  viewportUnitsBuggyfill.init();
  window.dataLayer = window.dataLayer || [];
  const app = {};

  const initContactFormSvelteApp = () => {
    if (document.getElementById("svelte-contact-form")) {
      const el = document.getElementById("svelte-contact-form");
      new contactForm({
        target: el,
      });
    }
  };
  initContactFormSvelteApp();

  const nav = function () {
    const burgers = select.all(".burger");
    const header = select(".header");
    const subMenus = select.all(".sub-menu", header);
    const nav = select(".nav", header);
    const backWrap = select(".brand-wrap", header);
    const back = select(".back", backWrap);
    let cover = select(".is-cover");
    const message = select("#message");

    if (message) {
      const messageClose = select("#message .close");
      messageClose.addEventListener("click", function () {
        message.style.opacity = 0;

        setTimeout(() => {
          message.remove();
        }, 200);
      });
    }

    function lock() {
      scrollLock(header);
    }

    function unlock() {
      scrollUnLock();
    }

    if (nav) {
      nav.addEventListener("click", (ev) => {
        // Close on the backdrop or the surrounding container (both show the
        // close cursor), but not the inner link column or its links.
        if (
          ev.target.classList.contains("nav") ||
          ev.target.matches(".nav > .container")
        ) {
          this.close();
        }
      });
    }

    setTimeout(() => {
      cl(header).rmCl("loader-open");
    }, 2000);
    setTimeout(() => {
      cl("body").rmCl("to-load");
      if (message) {
        cl(message).addCl("visible");
      }
    }, 2500);

    burgers.forEach((burger) => {
      burger.addEventListener("click", function () {
        if (burger.classList.contains("open")) {
          unlock();
        } else {
          lock();
        }
        const nav2 = select("header > nav");
        const contactFormContainer = select("header > div.nav");

        nav2.style.display = null;
        select(".header .nav").style.cursor = null;
        contactFormContainer.style.opacity = 0;
        // Contact form is hidden behind the menu here, so keep it out of the
        // pointer-event and accessibility trees while it's inactive.
        contactFormContainer.inert = true;

        cl(header).toCl("open");
        cl(burgers).toCls("open");

        // Remove header-hidden class when opening menu
        cl(header).rmCl("header-hidden");
      });
    });

    select.all(".sub-trig", header).forEach((trig, i) => {
      trig.addEventListener("click", () => {
        cl(subMenus[i]).addCl("active");
        cl(nav).addCl("sub-open");
      });
    });

    select.all(".sub-back", header).forEach((trig) => {
      trig.addEventListener("click", () => {
        cl(nav).rmCl("sub-open");
        cl(subMenus).rmCls("active");
      });
    });

    this.close = function () {
      cl(header).rmCl("open");
      cl(burgers).rmCls("open");
      cl(subMenus).rmCls("active");
      cl(nav).rmCl("sub-open");
      const contactFormContainer = select("header > div.nav");
      if (contactFormContainer) contactFormContainer.inert = true;
      unlock();
    };

    let lastScrollTop = 0;
    let scrollThreshold = 100; // Start hiding after scrolling 100px
    let hideTimeout = null;
    let scrollStopTimeout = null;

    this.scroll = function () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Detach from the top once scrolling begins so CSS can fade the bar in.
      // Above 1, not 0: GSAP's scroll normaliser pins iOS at 1px to dodge a
      // TouchEvent.clientY bug, which would otherwise stick the bar on load.
      cl(header)[scrollTop > 1 ? "addCl" : "rmCl"]("is-sticking");

      // Handle hide/show based on scroll direction
      // if (scrollTop > scrollThreshold) {
      //   if (scrollTop > lastScrollTop) {
      //     // Scrolling down
      //     cl(header).addCl("header-hidden");
      //     // Clear any pending hide timeout
      //     if (hideTimeout) {
      //       clearTimeout(hideTimeout);
      //       hideTimeout = null;
      //     }
      //     if (scrollStopTimeout) {
      //       clearTimeout(scrollStopTimeout);
      //       scrollStopTimeout = null;
      //     }
      //   } else if (scrollTop < lastScrollTop) {
      //     // Scrolling up
      //     cl(header).rmCl("header-hidden");

      //     // Clear any existing timeouts
      //     if (hideTimeout) {
      //       clearTimeout(hideTimeout);
      //       hideTimeout = null;
      //     }
      //     if (scrollStopTimeout) {
      //       clearTimeout(scrollStopTimeout);
      //     }

      //     // Detect when scrolling stops, then start the 5-second timer
      //     scrollStopTimeout = setTimeout(() => {
      //       const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      //       if (currentScrollTop > scrollThreshold) {
      //         hideTimeout = setTimeout(() => {
      //           const finalScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      //           if (finalScrollTop > scrollThreshold) {
      //             cl(header).addCl("header-hidden");
      //           }
      //         }, 5000);
      //       }
      //     }, 150); // Wait 150ms after last scroll event to consider scrolling "stopped"
      //   }
      // } else {
      //   // At top of page - clear timeouts and keep visible
      //   if (hideTimeout) {
      //     clearTimeout(hideTimeout);
      //     hideTimeout = null;
      //   }
      //   if (scrollStopTimeout) {
      //     clearTimeout(scrollStopTimeout);
      //     scrollStopTimeout = null;
      //   }
      //   cl(header).rmCl("header-hidden");
      // }

      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    };

    this.updateColor = function (parent) {
      cover = select(".is-cover", parent);
      const container = parent || select("[data-page-color]");
      const color = cover && cover.dataset.cover ? cover.dataset.cover : null;

      const pageColors =
        container && container.dataset.pageColor
          ? container.dataset.pageColor.split("|")
          : [];
      const pageColor = pageColors.length ? pageColors[0] : null;
      const pageBG = pageColors.length > 1 ? pageColors[1] : null;

      if (pageColors.length) {
        doc.body.style.color = pageColor;
        doc.body.style.backgroundColor = pageBG;
      } else {
        doc.body.style.color = "";
        doc.body.style.backgroundColor = "";
      }

      if (color && header) {
        header.style.color = color;
        cl(header).addCl("has-color");
      } else if (header) {
        header.style.color = "";
        cl(header).rmCl("has-color");
      }

      const segments = location.pathname.split("/");
      if (backWrap && back && segments.length > 2) {
        cl(backWrap).addCl("show-back");
      } else {
        cl(backWrap).rmCl("show-back");
      }
    };

    this.updateColor();
  };

  function activeNav() {
    const firstSegment = location.pathname.split("/")[1];
    const lastSegment = location.pathname.split("/").pop();

    const backLabels = {
      work: "More Work",
      articles: "More Articles",
      services: "More Services",
    };
    const navBack = document.getElementById("nav-back");
    if (navBack && backLabels[firstSegment]) {
      navBack.innerHTML = backLabels[firstSegment];
      navBack.href = "/" + firstSegment;
    }

    select.all(".header a, .nav a").forEach(function (nav) {
      const linkSegments = nav.pathname.split("/");
      const linkFirstSegment =
        linkSegments.length > 1 && linkSegments[1] !== ""
          ? linkSegments[1]
          : false;
      const linkSecondSegment =
        linkSegments.length > 2 && linkSegments[2] !== ""
          ? linkSegments[2]
          : false;

      if (firstSegment == "" && !linkFirstSegment && !linkSecondSegment)
        cl(nav).addCl("active");
      else if (linkSecondSegment && linkSecondSegment === lastSegment)
        cl(nav).addCl("active");
      else if (
        linkFirstSegment &&
        !linkSecondSegment &&
        linkFirstSegment === firstSegment
      )
        cl(nav).addCl("active");
      else cl(nav).rmCl("active");
    });
  }

  function smooth(el, offset) {
    if (!el || !app.smoother) return;
    if (typeof el === 'number') {
      app.smoother.scrollTo(el, true);
    } else {
      app.smoother.scrollTo(el, true, `top ${offset || 40}px`);
    }
    if (app.nav) {
      setTimeout(() => {
        app.nav.scroll();
      }, 1100);
    }
  }

  function setSmooth(parent) {
    select.all(".smooth-scroll", parent).forEach((anchor) => {
      anchor.addEventListener("click", (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        if (anchor.dataset.window) {
          smooth(window.innerHeight, 0, 1000);
        } else {
          const target = select(anchor.hash);
          if (target) smooth(target, 40, 1000);
        }
      });
    });
  }

  app.swipers = [];
  function swipers(parent) {
    app.swipers.forEach((sw) => sw.destroy());
    app.swipers = [];

    select.all(".swiper-regular", parent).forEach((sw) => {
      app.swipers.push(
        new Swiper(sw, {
          modules: [Autoplay, EffectFade, Pagination],
          effect: sw.classList.contains("fade-effect") ? "fade" : "slide",
          speed: 1000,
          loop: true,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false,
          },
          ...pipPagination(sw),
        })
      );
    });

    select.all(".swiper-cover", parent).forEach((sw) => {
      const autoplayDelay = sw.dataset.swiperAutoplay ? parseInt(sw.dataset.swiperAutoplay) : 4000;
      
      app.swipers.push(
        new Swiper(sw, {
          modules: [Autoplay, EffectFade, Pagination],
          speed: 1000,
          effect: "fade",
          loop: true,
          autoplay: {
            delay: autoplayDelay,
            disableOnInteraction: true,
          },
          ...pipPagination(sw),
        })
      );
    });

    function pipPagination(sw) {
      return {
        pagination: {
          el: select(".swiper-pagination", sw),
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '"><span class="pip-progress"></span></span>';
          },
        },
        on: {
          init: function () {
            updatePipProgress(this);
          },
          slideChange: function () {
            updatePipProgress(this);
          },
          autoplayTimeLeft: function (swiper, time, progress) {
            const activeBullet = select('.swiper-pagination-bullet-active .pip-progress', sw);
            if (activeBullet) {
              activeBullet.style.left = `${(0 - progress) * 100}%`;
            }
          },
          autoplayStop: function () {
            fillActivePip(this);
          },
          beforeTransitionStart: function (swiper, speed, internal) {
            // Swiper pauses autoplay until the wrapper's transitionend, which never fires
            // for instant internal moves (e.g. update() after the container is unhidden),
            // leaving the carousel stuck
            if (internal && speed === 0 && swiper.autoplay.paused) swiper.autoplay.resume();
          },
        },
      };
    }

    function updatePipProgress(swiper) {
      const bullets = select.all('.swiper-pagination-bullet .pip-progress', swiper.el);
      bullets.forEach((pip) => {
        pip.style.left = '-100%';
      });
      // Once autoplay has been stopped by the user, the active pip should read as complete
      if (!swiper.autoplay.running) fillActivePip(swiper);
    }

    function fillActivePip(swiper) {
      const activeBullet = select('.swiper-pagination-bullet-active .pip-progress', swiper.el);
      if (activeBullet) activeBullet.style.left = '0%';
    }

    setTimeout(function () {
      app.swipers.forEach((sw) => sw.update());
    }, 200);
  }

  // Background images are lazy-loaded via ScrollTrigger rather than IntersectionObserver,
  // which doesn't fire reliably against ScrollSmoother's transform-driven scroll.
  app.lazyTriggers = [];
  function setLazy(parent) {
    app.lazyTriggers.forEach((t) => t.kill());
    app.lazyTriggers = [];
    addLazy(parent || document);
    // Triggers may be created before layout settles, so recompute their start positions.
    ScrollTrigger.refresh();
  }

  // Set up (or eagerly reveal) lazy background images within `scope` WITHOUT
  // tearing down existing triggers — safe to call incrementally (e.g. paginated
  // appends). Caller is responsible for ScrollTrigger.refresh().
  function addLazy(scope) {
    (scope || document).querySelectorAll(".bg-image[data-src]:not(.loaded)").forEach((el) => {
      const reveal = () => {
        el.style.backgroundImage = `url('${el.getAttribute("data-src")}')`;
        el.classList.add("loaded");
      };

      // Anything already at or above the fold loads straight away (covers and
      // anything we've already scrolled past).
      if (el.getBoundingClientRect().top < window.innerHeight) {
        reveal();
        return;
      }

      // Otherwise defer until it nears the viewport, in sync with ScrollSmoother.
      // (IntersectionObserver doesn't fire against the smoother's transform scroll.)
      app.lazyTriggers.push(
        ScrollTrigger.create({
          trigger: el,
          start: "top bottom+=40%",
          once: true,
          onEnter: reveal,
        })
      );
    });
  }

  app.tilts = null;
  function setTilts(parent) {
    const tilts = select.all("[data-tilt]", parent);
    app.tilts = VanillaTilt.init(tilts);
  }

  app.pagTilts = [];
  const pagination = function (parent) {
    const cont = select(".paginated", parent);
    let page = cont && cont.dataset.pagNext !== "false" ? 2 : 1;
    let canFetch = true;

    function fetchPage(pageNo, callback) {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", window.location + "/p" + pageNo, true);
      xhr.responseType = "document";
      xhr.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200 && callback)
          callback(this.response);
      };
      xhr.send();
    }

    this.scroll = function () {
      if (cont && page > 1) {
        const contPos = cont.getBoundingClientRect().bottom;

        if (contPos < window.innerHeight * 1.5 && canFetch) {
          canFetch = false;

          fetchPage(page, function (resp) {
            const newCont = select(".paginated", resp);
            const elements = select.all(".pag-item", newCont);
            page =
              newCont && newCont.dataset.pagNext !== "false" ? page + 1 : 1;

            if (newCont && elements.length) {
              elements.forEach(function (el) {
                cont.appendChild(el);

                // Lazy-load the appended images now they're live in the DOM,
                // without tearing down the existing page's triggers.
                addLazy(el);
                animate_added(el);

                const tilt = select.all("[data-tilt]", el);
                if (tilt) app.pagTilts.push(VanillaTilt.init(tilt));
              });

              ScrollTrigger.refresh();
              canFetch = true;
            } else {
              canFetch = false;
            }
          });
        }
      }
    };
  };

  function forms(parent) {
    select.all(".ajax-form", parent).forEach((form) => {
      const button = select("button", form);

      let posting = false;

      function reset() {
        posting = false;
        cl(button).rmCl("is-loading");
        form.classList.add("is-posted");
        setTimeout(() => {
          form.reset();
          form.forEach((f) => cl(f).rmCl("filled"));
          form.classList.remove("is-posted");
        }, 3000);
      }

      form.addEventListener("submit", (e) => {
        e.preventDefault();
        e.stopPropagation();
        cl(button).addCl("is-loading");

        if (!posting) {
          posting = true;
          axios
            .post(window.location.href, serialize(form))
            .then(({ data }) => {
              reset();
              if (!data.success) {
                // Handle error silently or add proper error handling
              }
            })
            .catch((e) => {
              reset();
              // Handle error silently or add proper error handling
            });
        }
      });
    });
  }

  function quote(parent) {
    select.all(".block-quote", parent).forEach((q) => {
      const hoverElement = select(".hover-element", q);
      q.addEventListener("mouseover", () => {
        cl(q).addCl("is-hovered");
      });
      q.addEventListener("mouseleave", () => {
        cl(q).rmCl("is-hovered");
      });

      if (hoverElement) {
        q.addEventListener("mousemove", (ev) => {
          const rect = q.getBoundingClientRect();
          const x = ev.clientX - rect.left;
          const y = ev.clientY - rect.top;
          hoverElement.style.transform = `translate(${x}px, ${y}px)`;
        });
      }
    });
  }

  app.videRes = null;
  function initPage(parent) {
    activeNav();
    swipers(parent);
    setSmooth(parent);
    setLazy(parent);
    setTilts(parent);
    quote(parent);
    forms(parent);
    app.pagination = new pagination(parent);
    app.spoilers = new Spoilers(parent);
    app.faqs = new Faqs(parent);
    app.videRes = new videoResize(".has-cover-video");
    refresh_icons();
  }

  // Typeform trigger setup using event delegation - set up once
  function setupTypeformTrigger() {
    document.addEventListener("click", (e) => {
      const trigger = e.target.closest(".typeform-modal-trigger");
      if (trigger) {
        e.preventDefault();

        // Pages with their own form (Card Page "Form" field) scroll to it rather than opening the modal
        const pageForm = select("#page-form");
        if (pageForm) {
          smooth(pageForm);
          return;
        }

        const nav2 = select("header > nav");
        const contactFormContainer = select("header > div.nav");
        const burgers = select.all(".burger");
        const header = select(".header");

        nav2.style.display = "none";
        select(".header .nav").style.cursor = "auto";

        contactFormContainer.style.opacity = 1;
        // Contact form is now the active layer, so let it receive input and
        // expose it to assistive tech again.
        contactFormContainer.inert = false;

        cl(header).addCl("open");
        cl(burgers).addCls("open");

        // Remove header-hidden class when opening contact form
        cl(header).rmCl("header-hidden");
      }
    });
  }

  // Tim social icon sizing

  // The idiots at W3C made aspect-ratio elements collapse the container's width similar to position: absolute, so here we are:

  function refresh_icons() {
    var socials = document.querySelectorAll('.socials:not([data-static-icons]) a');
    Array.prototype.forEach.call(socials, function(el, i) {
        var social = socials[i];
        var social_h = null;
        social.removeAttribute('style');
        social_h = social.offsetHeight;
        social.style.aspectRatio = 'auto';
        social.style.width = social_h + 'px';
    });
  }

  // Fire it here, on document ready
  refresh_icons();

  // Needs to fire on resize because icons are sized relative to the text, and the text is responsive
  window.addEventListener('resize', function(event) {
    refresh_icons();
  });

  // Tim dev box functions

  var dev_box;

  var reported_width;
  var actual_width;
  var prev_width;
  var curr_media;
  var prev_media;
  var check_media;

  var w_xs = 360;
  var w_sm = 411;
  var w_md = 768;
  var w_lg = 1024;
  var w_xl = 1280;
  var w_2xl = 1512;
  var w_3xl = 1920;

  var page_pos;

  function refresh_devbox() {
      if (dev_box) {
          dev_box.textContent = curr_media + ' ' + actual_width + ' ' + page_pos;
      }
  }

  function refresh_all(resized = false) {

      // Get the actual browser width

      var disabled_width;
      var scrollbar_width;

      reported_width = window.innerWidth;
      document.body.style.overflow = 'hidden';
      disabled_width = window.innerWidth;
      document.body.style.overflow = '';

      if (window.navigator.userAgent.match(/Safari/i) && !window.navigator.userAgent.match(/Chrome/i)) {
          scrollbar_width = 0;
      } else {
          scrollbar_width = disabled_width - reported_width;
      }
      
      actual_width = reported_width + scrollbar_width;

      // Prevent height alterations such as those caused by iOS browser chrome expanding on scroll up from
      // triggering the refresh_all event which can cause stuttering in any dynamic positioned elements
      if (actual_width != prev_width || resized == false) {

          prev_width = actual_width;

          // If different to set media, media query has changed

          if (actual_width < w_xs ) {
              check_media = 'min (0+)';
          } else if (actual_width >= w_xs && actual_width < w_sm) {
              check_media = 'xs (360+)';
          } else if (actual_width >= w_sm && actual_width < w_md) {
              check_media = 'sm (411+)';
          } else if (actual_width >= w_md && actual_width < w_lg) {
              check_media = 'md (768+)';
          } else if (actual_width >= w_lg && actual_width < w_xl) {
              check_media = 'lg (1024+)';
          } else if (actual_width >= w_xl && actual_width < w_2xl) {
              check_media = 'xl (1280+)';
          } else if (actual_width >= w_2xl && actual_width < w_3xl) {
              check_media = '2xl (1512+)';
          } else if (actual_width >= w_3xl) {
              check_media = '3xl (1920+)';
          }

          // Media has changed
          if (check_media !== curr_media) {
              prev_media = curr_media;
              curr_media = check_media;
              // Add functions
          }
          
          // Media is greater than tablet
          if (actual_width >= w_md) {
              // Add functions
          }

          // Functions to rerun on any resizing
          refresh_devbox();

      }

  }

  function on_scroll() {

      // Handle differing browser support for scrollTop
      if (document.documentElement.scrollTop !== 0) {
          page_pos = document.documentElement.scrollTop;
      } else {
          page_pos = document.body.scrollTop;
      }
      
      refresh_devbox();

  }

  // End Tim dev box functions

  doc.addEventListener("DOMContentLoaded", function () {

    // Start Tim dev box events

    dev_box = document.querySelector('#dev-box');

    refresh_all();
    window.addEventListener('resize', function(event) {
        refresh_all(true);
    });

    on_scroll();
    window.addEventListener('scroll', function(event) {
        on_scroll();
    });

    // End Tim dev box events

    app.smoother = ScrollSmoother.create({
      wrapper: "#smooth-wrapper",
      content: "#smooth-content",
      smooth: 1.5,
      effects: false, // Parallax is applied per breakpoint in helpers/animate.js instead
      // Same as `normalizeScroll: true` (which uses { debounce: true, content: false }
      // when smoothing), plus allowNestedScroll so scrollable elements such as the
      // contact form modal scroll natively instead of having wheel/touch swallowed.
      normalizeScroll: { debounce: true, content: false, allowNestedScroll: true },
    });

    // Hidden states for the fades are set before the page is revealed, so nothing flashes
    const playLoadAnimations = init_animations();
    init_scroll_effects();

    // Stand down anti-FOUC measure only once ScrollSmoother has taken over scroll
    // handling. Revealing the page any earlier lets a user scroll the native page
    // before the smoother initializes, which permanently desyncs it.
    document.body.classList.add('document-ready');
    document.body.removeAttribute('style');
    playLoadAnimations();

    app.nav = new nav();
    initFormie();
    setupTypeformTrigger();
    initPage(select(".page"));
    init_page_leave();

    win.addEventListener(
      "scroll",
      throttle(function () {
        if (app.nav) app.nav.scroll();
        if (app.pagination) app.pagination.scroll();
      }, 50)
    );

    win.addEventListener(
      "resize",
      throttle(function () {
        if (app.videRes) app.videRes.resize();
      }, 300)
    );
  });
})(document, window);
